module.exports = __webpack_public_path__ + "img/pt-13.099234ac.jpg";